export default __webpack_public_path__ + "static/media/conteudo02.42016931.png";